import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/hy-am.js';
import 'react-toastify/dist/ReactToastify.css';
import add from "../../assets/img/add.svg";
import LittleButton from "../BlueButton/LittleButton.js";
import Loader from "../BlueButton/Loader.js";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import Api from "../../Api.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 500 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 400,
    overflow: 'auto',
    maxHeight: '97vh'
};
export default function FileUpload({ open, setOpen, task, setData }) {
    const [taskFileList, setTaskFileList] = useState([]);
    const [addTaskFileList, setAddTaskFileList] = useState([]);
    const [loadingUrl, setLoadingUrl] = useState("");
    const single = async () => {
        const { data } = await Api.getAgentTaskFiles(task.id)
        let taskSms = []
        if (data.length > 0) {
            data.forEach(sms => {
                if (sms.file !== null) {
                    taskSms.push({
                        id:sms.id,
                        file: sms.file,
                        file_name: sms.file.split('/')[sms.file.split('/').length - 1],
                        created_date: sms.created_date,
                        url: sms.file
                    });
                }
            });
        }
        setTaskFileList(taskSms)
    }
    const addFiles = async () => {
        try {
            for (const element of addTaskFileList) {
                const fd = new FormData();
                fd.append("task", String(task.id));
                fd.append("file", element);
                await Api.createAgentTaskFile(fd)

            }
            await single()
            SuccessToast()
            setOpen(false)
        } catch (e) {
            ErrorToast()
        }
    };

    const deleteFileBeforeAccept = (name) => {
        setAddTaskFileList((prevState => prevState.filter(el => el.name !== name)));
    };

    const raiseInvoiceClicked = (url) => {
        localStorage.setItem("pageData", "Data Retrieved from axios request");
        window.open(url, "_blank");
    };



    const deleteFileByUrl = async (id) => {
        try {
            setLoadingUrl(id);
            await Api.deleteAgentTaskFiles(id);
            setLoadingUrl("");
            await single()
            SuccessToast()
        } catch (e) {
            console.log(e);
            
            ErrorToast()
        }

    };

    useEffect(() => {
        (async () => {
            if (task) {
                await single()
            }
        })();
    }, [task]);
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='module w-100 h-100'>
                        <div className="file-close">
                            <div className="tool-tip-cont">
                                <div className="tool-tip">Փակել</div>
                                <i className="fas fa-times" onClick={() => setOpen(false)} />
                            </div>
                        </div>

                        <label>
                            <img className="icon-new-file" src={add} alt="Add" />
                            <input
                                type="file"
                                multiple
                                className='input-icon'
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    setAddTaskFileList([...addTaskFileList, ...files]);
                                }}
                            />
                        </label>

                        {addTaskFileList.length > 0 && addTaskFileList.map((item, index) => (
                            <div className="modue-item" key={index}>
                                <div className="item-date">
                                    <div className="file-item-name">{item.name}</div>
                                    <div className="tool-tip-cont">
                                        <div className="tool-tip">Ջնջել</div>
                                        <i className="fas fa-trash-alt"
                                            onClick={() => deleteFileBeforeAccept(item.name)} />
                                    </div>
                                </div>
                            </div>
                        ))}

                        {addTaskFileList.length > 0 && (
                            <div className="file-button">
                                <LittleButton title="Հաստատել" onChangeValue={addFiles} />
                            </div>
                        )}

                        <hr />

                        {taskFileList.length > 0 && taskFileList.map((item, index) => {
                            return (
                                <div className="modue-item" key={index}>
                                    <span className="model-item-date">
                                        {moment(item.created_date || task.created_date).format('LLL')}
                                    </span>
                                    <div className="item-date">
                                        <div className="file-item-name" onClick={() => raiseInvoiceClicked(item.file)}>
                                            {item.file_name}
                                        </div>
                                        {loadingUrl !== item.url ? (
                                            <div className="tool-tip-cont">
                                                <div className="tool-tip">Ջնջել</div>
                                                <i className="fas fa-trash-alt" onClick={() => deleteFileByUrl(item.id)} />
                                            </div>
                                        ) : (
                                            <Loader size={10} />
                                        )}
                                    </div>
                                </div> 
                            )
                        })}
                    </div>
                </Box>
            </Fade>
        </Modal>
    )
}
